import {I18n} from "react-redux-i18n";

const visitorsSearchFields = (searchFieldValues) => {
    return {
        rows: [{
                hasTopBreak: false,
                hasBottomBreak: false,
                fields: [
                    {
                        id: "name",
                        label: I18n.t("visitors.searchFields.name"),
                        type: "text",
                        value: searchFieldValues.name.value,
                    },{
                        id: "email",
                        label: I18n.t("visitors.searchFields.email"),
                        type: "text",
                        value: searchFieldValues.email.value,
                    },{
                        id: "companyName",
                        label: I18n.t("visitors.searchFields.company"),
                        type: "text",
                        value: searchFieldValues.companyName.value,
                    }
                ]
            },
        ]
    }
};

export {
    visitorsSearchFields
}